module.exports = __webpack_public_path__ + "img/66.45a58770.jpg";